import { styled, Box, Typography } from '../../base';

export const StyledTrigger = styled(Box)<{ isopen: 'true' | 'false' }>(
    ({ theme, isopen }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1, 2),
        cursor: 'pointer',
        width: '100%',
        minHeight: 42,
        transition: 'border-radius 0.2s ease, border-bottom 0.2s ease',
        ...(isopen === 'true' && {
            borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
        }),
    })
);

export const StyledTriggerText = styled(Typography)<{
    isplaceholder: 'true' | 'false';
}>(({ theme, isplaceholder }) => ({
    color:
        isplaceholder === 'true'
            ? theme.palette.grey[600]
            : theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

export const StyledOptionRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    minHeight: 40,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
}));

export const StyledOptionLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[600],
    wordBreak: 'break-word',
}));
